import React, { useState, useMemo, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { REQUEST_TARGET_MODULES } from "../../../../../../Library/APIsTarget";
import LoadingBtn from "../../../../../Widgets/LoadingBtn";

export default function CourseOvering({ student, studentid, curriculum, data, stdStatus }) {
  const listData = data;
  const current_semester = stdStatus?.semester || 0;
  const tableContainerRef = useRef(null);


  const param_curr = {
    curr_id: curriculum?.id || 0,
    studentid: studentid,
    clu_id: stdStatus?.clu?.id || 0,
    clu_spec_id:stdStatus?.clu_spec?.id || 0,
  }

  const [result, setResult] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [course_curriculum, setCourseCurriculum] = useState(listData);
  const LoadCurriculum = async (param) => {
    setResult({ loading: true, data: [], message: "" });
    setCourseCurriculum([]);
    const param_post = {
      parameters: param,
      target_data: "PROGRESS_CURR",
    };
    const results = await REQUEST_TARGET_MODULES(param_post);
    if (results.data && Object.values(results.data).length > 0) {
      const course_dt = results.data?.curr_dt || [];
      console.log("curr",course_dt);
      if (course_dt && Object.values(course_dt).length > 0) {
        const sort_course = course_dt.sort((a, b) => (a.semester < b.semester ? 1 : -1));
        console.log(sort_course);
        console.log(listData);
        const r_course = CombinedCourseCurriculum(listData, sort_course);
        setCourseCurriculum(r_course);
      } else {
        setCourseCurriculum(listData);
      }
      setResult({ loading: false, data: results.data, message: "" });
    } else {
      setResult(results);
      setCourseCurriculum(listData);
    }
  }

  useEffect(() => {
    if(studentid && data){
      LoadCurriculum(param_curr);
    }
  }, [studentid, data])

  let csemester = 0;
  /*==DATATABELS CONFIG==*/
  const [search, setSearch] = useState("");

  const ResultData = useMemo(() => {
    let computedData = course_curriculum;
    if (Object.values(course_curriculum).length > 0) {
      computedData = course_curriculum.map((c) => {
        var obj = {};
        obj.coursetitle = c.coursetitle;
        obj.course_code = c.code;
        obj.course_credit = c.credit;
        obj.course_id = c.course_id;
        obj.grade_fin = c.grade_fin;
        obj.semester = c.semester;
        obj.section_id = c.section_id;
        obj.in_semester = c.in_semester;
        return obj;
      });
    }

    computedData.sort((a, b) => (a.semester < b.semester ? 1 : -1));

    if (search) {
      computedData = computedData.filter((listData) => {
        return String(listData.coursetitle.toLowerCase()).includes(
          search.toLowerCase()
        );
      });
    }

    return computedData;
  }, [course_curriculum, search]);
  /*==END DATATABELS CONFIG==*/

  useEffect(() => {
    if (!result.loading && ResultData.length > 0 && current_semester > 0) {
      setTimeout(() => {
        const semesterElement = document.getElementById(`semester-${current_semester}`);
        const tableContainer = tableContainerRef.current;
        
        if (semesterElement && tableContainer) {
          // Hitung posisi scroll
          const scrollPosition = semesterElement.offsetTop - tableContainer.offsetTop + 130;
          console.log('Scroll Position:', scrollPosition);
        
          
          // Scroll ke posisi yang diinginkan
          tableContainer.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
          
          // Optional: Tambahkan highlight effect
          semesterElement.classList.add('highlight-semester');
          setTimeout(() => {
            semesterElement.classList.remove('highlight-semester');
          }, 2000);
        }
      }, 100);
    }
  }, [result.loading, ResultData, current_semester]);


  return (
    <div className="card card-custom card-stretch gutter-b">
      <div className="card-header align-items-center border-0 mt-4">
        <h3 className="card-title align-items-start flex-column">
          <span className="font-weight-bolder text-dark">
            {student ? student.firstname + "'s" : ""} Course 
            <span className="ml-1">
              {Object.values(result.data).length === 0 ? "History" : ""}
            </span>
          </span>
          {Object.values(result.data).length > 0 &&
            <Link to={`/counseling/student/${studentid}/curriculum`} target="_blank" title="View Curriculum" className="text-primary font-weight-bold font-size-lg">
              {result.data?.name}
            </Link>
          }
        </h3>
      </div>
      <div className="card-body pt-0">
        <div className="filtering">
          <div className="input-icon input-icon-right mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <span>
              <i className="flaticon2-search-1 icon-md"></i>
            </span>
          </div>
        </div>
        <div
          ref={tableContainerRef}
          className="table-list"
          style={{ maxHeight: "750px", overflowY: "auto" }}
        >
          <div className="table-responsive">
            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
              <thead className="d-none">
                <tr className="text-uppercase">
                  <th>
                    <span className="text-dark">Course</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4} className="p-1"></td>
                </tr>
                {result.loading ? <LoadingBtn /> :
                  ResultData.length > 0 ? (
                    ResultData.map((v, index) => {
                      let elementTR = "";
                      if (csemester !== v.semester) {
                        elementTR = (
                          <tr className={v.in_semester === 1 ? "bg-primary" : "bg-light"} key={v.semester} id={`semester-${v.semester}`} style={{ transition: 'background-color 0.3s ease' }}>
                            <th colSpan="7">
                              <span className={v.in_semester === 1 ? "text-white" : ""}>
                                Semester {v.semester}
                              </span>
                            </th>
                          </tr>
                        );
                      }
                      csemester = v.semester;
                      return (
                        <>
                          {elementTR}
                          <tr key={index}>
                            <td colSpan={3} className="py-1 px-0">
                              <div className={"border p-3 " + (v.in_semester === 1 ? "border-primary bg-light-primary" : "")}>
                                <div className="d-flex justify-content-start align-items-start">
                                  <div className="my-course w-100 ">
                                    <span className="font-weight-bolder mb-1">
                                      {v.coursetitle}
                                    </span>
                                    <div>
                                      <span className="text-muted font-weight-bold">
                                        {v.course_code}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="info-course w-100px">
                                    <span className="font-weight-bolder d-block">
                                      Credit
                                      <span className="ml-2 text-dark font-weight-bold">
                                        {v.course_credit}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="grade-act mx-5">
                                    <span
                                      className={
                                        "font-weight-bolder font-size-lg badge " +
                                        (v.grade_fin !== "A" &&
                                          v.grade_fin !== "B" &&
                                          v.grade_fin !== "C"
                                          ? "badge-danger"
                                          : "badge-info")
                                      }
                                      title={"Grade " + v.grade_fin}
                                    >
                                      {v.grade_fin ? v.grade_fin : "-"}
                                    </span>
                                  </div>
                                </div>

                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={3}>No record found</td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style jsx>{`
        .highlight-semester {
          animation: highlightFade 2s ease-in-out;
        }
        
        @keyframes highlightFade {
          0% { background-color: #FFF4DE; }
          50% { background-color: #FFE5A1; }
          100% { background-color: transparent; }
        }
      `}</style>
    </div>
  );
}


const CombinedCourseCurriculum = (listData, course_dt) => {
  const listDataMap = new Map(listData.map(item => [item.course_id, item]));

  const list_course = course_dt.map(c => {
    const baseObject = {
      course_id: c.course_id,
      coursetitle: c.course_id ? (c?.course?.coursetitle || "") : "Elective Course",
      code: c?.course?.code || "",
      credit: c?.credit || "",
      semester: c?.semester,
      course_type: c?.course_type || ""
    };

    // Mencari data yang sesuai dari listData
    const matchingData = listDataMap.get(c.course_id);

    // Jika ada data yang cocok, tambahkan properti tambahan
    if (matchingData) {
      return {
        ...baseObject,
        grade_fin: matchingData.grade_fin || "",
        section_id: matchingData.section_id || "",
        in_semester: matchingData.in_semester || 0
      };
    }

    return baseObject;
  });

  return list_course;
}